import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
  {
    path: '/profile',
    name: 'CurrentUserProfile',
    component: () => import('@/views/Users/Index'),
    beforeEnter: requireAuth,
    alias: '/user/me',
    meta: { hideBanner: true },
  },

  {
    path: '/user/:id',
    name: 'UserProfile',
    component: () => import('@/views/Users/Index'),
    beforeEnter: requireAuth,
  },
  {
    path: '/profile/quicklinks',
    name: 'CurrentUserQuickLinks',
    component: () => import('@/views/Users/Links'),
    beforeEnter: requireAuth,
  },
  {
    path: '/profile/notifications',
    name: 'CurrentUserNotifications',
    component: () => import('@/views/Users/Notifications'),
    beforeEnter: requireAuth,
  },
  {
    path: '/quicklinks/:type',
    name: 'ViewLinks',
    component: () => import('@/views/Users/LinkView'),
    beforeEnter: requireAuth,
    alias: '/quicklinks',
  },
  {
    path: '/profile/quicklinks/add',
    name: 'CurrentUserQuickLinksAdd',
    components: {
      default: () => import('@/views/Users/Links'),
      panel: () => import('@/views/Users/LinksAddEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: false,
      whiteBg: true,
    },
  },
  {
    path: '/profile/quicklinks/:id/edit',
    name: 'CurrentUserQuickLinksEdit',
    components: {
      default: () => import('@/views/Users/Links'),
      panel: () => import('@/views/Users/LinksAddEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: false,
      whiteBg: true,
    },
  },
  {
    path: '/profile/edit/:section',
    name: 'ProfileEditSection',
    components: {
      default: () => import('@/views/Users/Index'),
      panel: () => import('@/views/Users/EditProfile'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: false,
    },
  },
];

/**
 * Admin routes
 */
const AdminRoutes = [
  {
    path: '/admin/users',
    name: 'Users',
    component: () => import('@/views/admin/Users'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true, filterBlocked: false },
  },

  {
    path: '/admin/users/blocked',
    name: 'BlockedUsers',
    component: () => import('@/views/admin/Users'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true, filterBlocked: true },
  },

  // User -> Create
  {
    path: '/admin/users/create',
    name: 'UserCreate',
    components: {
      default: () => import('@/views/admin/Users'),
      panel: () => import('@/views/admin/users/UserCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
      permissions: ['edit_users'],
    },
  },

  // User -> Edit
  {
    path: '/admin/users/:userId/edit',
    name: 'UserEdit',
    components: {
      default: () => import('@/views/admin/Users'),
      panel: () => import('@/views/admin/users/UserEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
      permissions: ['edit_users'],
    },
  },
];

export default [...FeRoutes, ...AdminRoutes];
